<template>
  <div id="TaskModule">
    <div id="tasks" v-if="list">
      <v-container class="pa-0">
        <v-layout>
          <router-link to="/tasks/add">
          <v-flex class="xs12 sm12 mb-5">
            <v-btn fab absolute right class="mr-3 pf-btn-fab">
              <v-icon>add</v-icon>
            </v-btn>
          </v-flex>
          </router-link>
        </v-layout>       
      </v-container>
      <v-card-title>
          <v-spacer></v-spacer>
          <v-spacer></v-spacer>
          <v-spacer></v-spacer>
          <v-select
            v-model="search"
            append-icon="search"
            label="Search by Membership" 
            :items="membershipList"
            clearable
            single-line
          ></v-select>
      </v-card-title>
      <v-card class="mt-3">
        <v-data-table
          disable-initial-sort
          :headers="headers"
          :items="Task"
          :search="search" 
          class="pf-data-table"
          ref="sortableTable"
          :pagination.sync="pagination" 
        >
          <template v-slot:items="props">
            <tr class="sortableRow" :key="itemKey(props.item)">
            <td>{{ props.item.name }}</td>
            <td>{{ props.item.identifier }}</td>
            <td>{{ props.item.membership.join(', ') }}</td>
            <td align="right">
              <v-btn icon class="ma-0" @click="editItem(props.item)">
                <v-icon size="22" color="grey darken-2">edit</v-icon>
              </v-btn>
              <v-btn style="cursor: move" icon @mouseenter="alertMessage" class="sortHandle">
                <v-icon color="grey darken-2">open_with</v-icon>
              </v-btn>
              <v-btn icon class="ma-0" @click="deleteItem(props.item)">
                <v-icon size="22" color="grey darken-2">delete_outline</v-icon>
              </v-btn>
            </td>
            </tr>
          </template>
        </v-data-table>
      </v-card>
    </div>
    <div id="taskEdit" v-if="!list">
      <div id="taskEdit">
      <v-layout wrap row mb-1>
      <v-flex md6 pb-4 style="min-height:70px;">
        <v-btn fab left class="ml-3 pf-btn-fab" @click="backToList()">
          <v-icon>arrow_back</v-icon>
        </v-btn>
         </v-flex>
        <v-flex offset-md1 md5 v-if="selectedData">
        <div style="float:right">
          <v-btn class="pf-btn pf-btn-cancel" @click="backToList()">
            <v-icon size="16" class="pr-1">cancel</v-icon>
            <div>Cancel</div>
          </v-btn>
          <v-btn class="pf-btn pf-btn-save" @click="save">
            <v-icon size="16" class="pr-1">check_circle</v-icon>
            <div>Save</div>
          </v-btn>
        </div>
      </v-flex>
    </v-layout>
    <v-form ref="taskEdit">
      <v-container>
        <v-layout>
          <v-flex class="xs12 sm6 md7">
            <v-text-field label="Task name" :rules="rules" v-model.trim="editableTask.name" class="required pr-4 pl-4" @input="changedData" required></v-text-field>
          </v-flex>
        </v-layout>
        <v-layout>
          <v-flex class="xs12 sm6 md7">
            <v-text-field label="Task identifier" :rules="rules" v-model.trim="editableTask.identifier" class="required pr-4 pl-4" @input="changedData" required></v-text-field>
          </v-flex>
        </v-layout>
        <v-layout>
          <v-flex class="xs12 sm6 md7">
            <v-textarea label="Description" rows="3" :rules="descriptionRules" v-model.trim="editableTask.description" class="required pr-4 pl-4" @input="changedData" required></v-textarea>
          </v-flex>
        </v-layout>
      <v-layout>
        <v-flex class="xs12 sm6 md7">
          <v-select @input="changedData" small-chips deletable-chips multiple :rules="membershipRules" :items="membershipList" v-model="editableTask.membership" label="Membership" class="required pr-4 pl-4" required></v-select>
        </v-flex>
      </v-layout>
      <v-layout>
        <v-flex class="xs12 sm6 md7">
          <v-text-field label="Relative UI action link" :rules="actionLinkRules" v-model.trim="editableTask.action_link" hint="Example: /path/to/page" persistent-hint class="pr-4 pl-4" @input="changedData"></v-text-field>
        </v-flex>
      </v-layout>
      <v-layout>
        <v-flex class="xs12 sm6 md7">
          <v-select label="Whether to force user to complete?" :items="[{ text: 'Yes', value: true }, { text: 'No', value: false }]" v-model.trim="editableTask.force_complete" class="pr-4 pl-4" @input="changedData"></v-select>
        </v-flex>
      </v-layout>

      <v-layout v-for="(link, index) in links" :key="index">
          <v-flex class="xs12 sm6 md7">
            <v-text-field label="Link" hint="Ex: https://example.com, http://example.com" :rules="urlRules" v-model="link.url" name="links[][url]" class="pr-4 pl-4" @input="changedData"></v-text-field>
          </v-flex>
          <v-btn icon class="mt-3 mr-3 mb-3 ml-0" @click="removeLink(index)">
            <v-icon size="22" color="grey darken-2">delete_outline</v-icon>
          </v-btn>
      </v-layout>
      <v-btn type="button" v-on:click="addNewLink" class="btn-link pf-btn-fab">Add link</v-btn>
      </v-container>
    </v-form>
      <v-layout class="editor-button-container">
        <v-flex xs12 class="button-container text-xs-right" v-if="selectedData">
          <div class="d-inline-flex">
            <v-btn class="pf-btn pf-btn-cancel" @click="backToList()">
              <v-icon size="16" class="pr-1">cancel</v-icon>
              <div>Cancel</div>
            </v-btn>
            <v-btn class="pf-btn pf-btn-save" @click="save">
              <v-icon size="16" class="pr-1">check_circle</v-icon>
              <div>Save</div>
            </v-btn>
          </div>
        </v-flex>
      </v-layout>
  </div>
    </div>
  </div>
</template>
<script>
/* global session store config */
import draggable from 'vuedraggable';
import Sortable, { MultiDrag, Swap } from 'sortablejs';
import swal from 'sweetalert2';
import { getCollection, remove, update, validateUrl } from '../../helpers/helpers';
import Vue from 'vue';
import { mapGetters } from 'vuex';

export default {
  data: () => ({
    editIndex: -1,
    list: true,
    itemKeys: new WeakMap(),
    currentItemKey: 0,
    search: '',
    headers: [
      { text: 'Task', value: 'name', align: 'left' },
      { text: 'Task ID', value: 'identifier' },
      { text: 'Membership', value: 'membership' },
      { text: '', sortable: false },
    ],
    membershipList: [
      'Network',
      'Featured',
      'Preferred'
    ],
    pagination: {
      sortBy: 'sort_no', // The field that you're sorting by
      descending: false,
      rowsPerPage: config.dom.rowsPerPage,
    },
    selectedData: false,
    editableTask: {},
    link: {
      url: ''
    },
    links: [],    
    rules: [
      v => !!v || 'Please fill this field'
    ],
    descriptionRules: [
      v => !!v || 'Task description is required'
    ],
    membershipRules: [
      v => v.length > 0 || 'membership is required'
    ],
    actionLinkRules: [
      // This should validate if the URI is in the format /path/to/page
      v => !v || v.trim() === '' || /^\/[a-zA-Z0-9_\-\/]+$/.test(v) || 'Please enter valid relative URL'
    ],
    urlRules: [
      v => v === '' || validateUrl(v) || 'Please enter valid URL'
    ]
  }),
  beforeRouteEnter (to, from, next) {
    if (!session.isOnline()) {
      next({ path: '/login' });
    } else {
      next();
    }
  },
  computed: {
    ...mapGetters(['Task'])
  },
  created () {
    this.getTasks();
  },
  mounted () {
    (() => new Sortable(
      this.$refs.sortableTable.$el.getElementsByTagName('tbody')[0],
      {
        draggable: '.sortableRow',
        handle: '.sortHandle',
        onEnd: this.dragReorder,
        forceFallback: 'false'
      }))();
  },
  methods: {
    alertMessage () {
      if (this.search) {
        swal.fire({
          title: 'Un Select a membership to enable the sort option!',
          type: 'warning',
          showCancelButton: false,
          confirmButtonColor: '#3085d6',
          cancelButtonColor: '#d33',
          confirmButtonText: 'Okay',
        });
      }
    },
    async getTasks () {
      if (!this.Task.length) {
        let entity = `Task`;
        let { error, data } = await getCollection(entity, true);
        if (error) {
          console.log(error);
        } else {
          if (data.length > 0) {
            store.commit('setTask', data);
          }
        }
      }
    },
    deleteItem (item) {
      swal.fire({
        title: 'Are you sure?',
        text: "You won't be able to revert this!",
        type: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Yes, delete it!'
      }).then((result) => {
        if (result.value) {
          (async () => {
            let { error, data, status } = await remove('Task', item.id);
            if (error) {
              console.log('error', error);
            } else {
              const index = this.Task.indexOf(item);
              this.Task.splice(index, 1);
              swal.fire(
                'Deleted!',
                `The task "${item.name}" has been deleted.`,
                'success'
              );
            }
          })();
        }
      });
    },
    itemKey (item) {
      if (!this.itemKeys.has(item)) this.itemKeys.set(item, ++this.currentItemKey);
      return this.itemKeys.get(item);
    },
    async dragReorder ({ oldIndex, newIndex }) {
      // if (this.search) {
      //   let sortMembership = await this.Task.filter(task => task.membership === this.search);
      //   const movedItem = sortMembership.splice(oldIndex, 1)[0];
      //   sortMembership.splice(newIndex, 0, movedItem);
      //   let allMembership = await this.Task.filter(task => task.membership !== this.search);
      //   let result = await sortMembership.map(function (task, index) {
      //     let o = Object.assign({}, task);
      //     o.sort_no = index + 1;
      //     return o;
      //   });
      //   let totalTask = [...result, ...allMembership];
      //   store.commit('setTask', totalTask);
      //   this.updateSorting(result);
      // }
      if (!this.search) {
        let sortMembership = [...this.Task];
        const movedItem = sortMembership.splice(oldIndex, 1)[0];
        sortMembership.splice(newIndex, 0, movedItem);
        let result = await sortMembership.map(function (task, index) {
          let o = Object.assign({}, task);
          o.sort_no = index + 1;
          return o;
        });
        let totalTask = [...result];
        store.commit('setTask', totalTask);
        this.updateSorting(result);
      }
    },
    async updateSorting (result) {
      for (let i = 0; i < result.length; i++) {
        let task = result[i];
        let postData = {
          name: task.name,
          description: task.description,
          membership: task.membership,
          links: task.links,
          identifier: task.identifier,
          sort_no: task.sort_no
        };
        let id = task.id;
        let { error, data } = await update('Task', postData, id);
        if (error) {
          console.log(error);
        }
      }
    },
    changedData () {
      this.selectedData = true;
    },
    editItem (item) {
      this.links = [];
      this.editIndex = this.Task.indexOf(item);
      window.getApp.$emit('pageSubHeader', 'Edit');
      this.list = false;
      this.editableTask = { ...item };
      let linkRow = [];
      for (let i = 0; i < item.links.length; i++) { 
        linkRow = { 'url': item.links[i] };
        this.links.push(linkRow);
      }
    },
    backToList () {
      window.getApp.$emit('pageSubHeader', '');
      this.list = true;
      this.editIndex = -1;

    },
    async save () {
      if (this.$refs.taskEdit.validate()) {
        let linkArray = [];
        for (let i = 0; i < this.links.length; i++) { 
          linkArray.push(this.links[i].url);
        }
        this.selectedData = false;
        let postData = {
          name: this.editableTask.name,
          description: this.editableTask.description,
          identifier: parseInt(this.editableTask.identifier, 10),
          membership: this.editableTask.membership,
          links: linkArray,
          sort_no: this.editableTask.sort_no,
          action_link: this.editableTask.action_link || '',
          force_complete: this.editableTask.force_complete || false
        };
        let id = this.editableTask.id;
        let { error, data } = await update('Task', postData, id);
        if (error) {
          this.selectedData = true;
          console.log('error', error);
        } else {
          this.Task[this.editIndex] = data;
          this.loading = false;
          swal.fire({
            type: 'success',
            title: 'Task updated successfully',
            showConfirmButton: false,
            timer: 2500,
            onClose: () => {
              this.editIndex = -1;
              this.list = true;
              this.links = [];
              window.getApp.$emit('pageSubHeader', '');
            }
          });
        }
      }
    },
    addNewLink: function () {
      this.links.push(Vue.util.extend({}, this.link));
    },
    removeLink: function (index) {
      Vue.delete(this.links, index);
      this.selectedData = true;
    },
  }
};
</script>
<style scoped>
#TaskModule >>> .v-textarea textarea {
    margin-top: 12px !important;
  }
</style>



// WEBPACK FOOTER //
// src/pages/Tasks/list.vue